import {AnimationBaseController, IAnimationControllerConfiguration, Inject, ModelEvents} from "@denishussar/html5-game-engine";
import {LoanLogic} from "../Logic/LoanLogic";
import {LoanAvatarEnum, LoanModel, LoanThingsEnum} from "../Models/LoanModel";
import {ButtonController, IButtonControllerOptions} from "./ButtonController";
import {AnimationContents} from "../../../../../../AnimationContents";
import { AchievementType } from "../../../../../Models/Game/AchievementModel";
import { GameLogic } from "../../../../../Logic/GameLogic";
import { MiniGameTypeEnum } from "../../../../../Models/Game/MiniGameModel";

export class LoanController extends AnimationBaseController {
    $model: LoanModel;

    private _width: number = 0;
    private _height: number = 0;

    private _screenWidth: number = 0;
    private _screenHeight: number = 0;
    private _screenScale: number = 1;

    private _wrongAnswerCounter: number = 0;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: LoanLogic,
        @Inject private _GameLogic: GameLogic,
        @Inject private _modelEvents: ModelEvents
    ) {
        super("ApproveLoan");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            animationContent: AnimationContents.LOAN_JSON,
            libraryName: "approve_the_loan_container",
            modelWatch: {
                things: (things: LoanThingsEnum) => {
                    this._startChildAnimations()
                },
                avatars: (things: LoanAvatarEnum) => {
                    this._startChildAnimations()
                },
            },
        };
    }

    private _childAnimation: [string, string, string] = [
        "avatars",
        "things",
        "name",
    ];

    private _startChildAnimations() {
        this._childAnimation.forEach((child) => {
            this.gotoAndStopByQuery(
                `mini_game_approve_the_load.${child}`,
                this.$model[child]
            );
        });
    }

    
    protected onInitialize(): void {
        this._gameLogic.getRandomCredit()
        this.$model.buttons.forEach((action) => {
            this.addChildController(
                {
                    instanceName: `mini_game_approve_the_load.buttons.button_${action}`,
                    view: ButtonController,
                    model: action,
                    options: <IButtonControllerOptions>{
                        onClick: () => {
                            if (this._gameLogic.startAction(action) || this._gameLogic.isWin()) {
                                if (this._gameLogic.isWin()) {
                                    this._options.onComplete();
                                    if (!this._wrongAnswerCounter) {
                                        this._GameLogic.isAchievements(AchievementType.Responsibility, MiniGameTypeEnum.approve_the_loan)
                                        this._GameLogic.isAchievements(AchievementType.Participation, MiniGameTypeEnum.approve_the_loan)
                                    }
                                }
                                if (this._wrongAnswerCounter > 0 && this._gameLogic.isWin()) { 
                                    this._options.onFail();
                                }
                            } else {
                                this._wrongAnswerCounter++ 
                            } 
                        },
                    },
                },
                "button_" + action
            );
        });
        this._startChildAnimations();

        this._width = this.display.width;
        this._height = this.display.height;
    }

    protected onResize(width: number, height: number, scale: number) {
        this._screenWidth = width;
        this._screenHeight = height;
        this._screenScale = scale;

        this.updateScale();
    }

    protected onLandscape(): void {
        this.updateScale();
    }

    protected onPortrait(): void {
        this.updateScale();
    }

    private updateScale(): void {
        this.display.scale.set(Math.min(this._screenWidth / this._width / this._screenScale, this._screenHeight / this._height / this._screenScale));
    }
}
